import { ContentText, MenuBackStyle } from "./style-component"
import { useNavigate } from "react-router-dom";

export const IconLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 4.25L6 8.25L10 12.25" stroke="currentColor" strokeOpacity="0.9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MenuBack = ({ style }: { style?: React.CSSProperties }) => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/home');
    }
  }

  return (
    <MenuBackStyle style={style}>
      <button
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', border: 'none', boxShadow: 'none', background: 'none', padding: 0 }}
        onClick={handleGoBack}
      >
        <ContentText>
          <IconLeft />
          <span>Regresar</span>
        </ContentText>
      </button>
    </MenuBackStyle>
  )
}

export default MenuBack;
